import Config from "config.json";

export const apiBaseUrl = Config.REACT_APP_API_BASE_URL
